<template>
  <!-- 关于畅月 -->
  <div>
    <div v-if="this.$route.path == '/pc/about'">
      <!-- 顶部导航 -->
      <TopNav></TopNav>
      <!-- 关于畅月轮播图 -->
      <AboutBanner></AboutBanner>
      <!-- 畅月里程碑 -->
      <Milepost></Milepost>
      <!-- 权威认证 -->
      <Authority></Authority>
      <!-- 企业文化 -->
      <Culture></Culture>
      <!-- 底部导航 -->
      <ButtonNav></ButtonNav>
    </div>
    <div v-else>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import TopNav from "../../../components/pc/components/TopNav.vue";
import ButtonNav from "../../../components/pc/components/BottomNav.vue";
import AboutBanner from "../../../components/pc/About/AboutBanner.vue";
import Milepost from "../../../components/pc/About/Milepost.vue";
import Authority from "../../../components/pc/About/Authority.vue";
import Culture from "../../../components/pc/About/Culture.vue";

export default {
  setup() {
    return reactive({});
  },
  components: {
    TopNav,
    ButtonNav,
    AboutBanner,
    Milepost,
    Authority,
    Culture,
  },
};
</script>
